import template from 'text!./confirmationBackButton.html';

export default {
    template,
    binds: {
        ngClick: '&'
    }
};